import { render, staticRenderFns } from "./AzChatPanel.vue?vue&type=template&id=d358a236&"
import script from "./AzChatPanel.vue?vue&type=script&lang=js&"
export * from "./AzChatPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports